export default {
  title: 'Do you want to delete this album?',
  text: 'This operation can not be reverted and the album and all its images will be deleted forever.',
  deny: 'Keep the album',
  confirm: 'Delete the album',
};
